import { Instagram, Facebook, Youtube, Phone, Mail, MapPin } from "lucide-react";
import logoFull from "@/assets/logo-full.png";
import tabocaLogoWhite from "@/assets/taboca-logo-white.png";

const Footer = () => {
  return (
    <footer 
      className="py-12 md:py-16 text-white"
      style={{
        background: "hsl(16 98% 50%)"
      }}
    >
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-2 gap-12 mb-12">
            {/* Logo and Description */}
            <div>
              <img 
                src={logoFull} 
                alt="Minha Casa Mais Bonita" 
                className="h-24 mb-6"
              />
              <p className="text-white/90 text-lg leading-relaxed mb-6">
                Programa idealizado por Taboca Arquitetura e Cidades.
                <br />
                Arquitetura acessível e transformadora para famílias brasileiras.
              </p>
              <img 
                src={tabocaLogoWhite} 
                alt="Taboca Arquitetura e Cidades" 
                className="h-14 opacity-90"
              />
            </div>

            {/* Contact Info */}
            <div>
              <h3 className="text-2xl font-bold mb-6">Fale conosco</h3>
              <div className="space-y-4">
                <a 
                  href="https://wa.me/5519997330658"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-3 text-white/90 hover:text-white transition-colors group"
                >
                  <div className="w-10 h-10 rounded-full bg-white/20 flex items-center justify-center group-hover:bg-white/30 transition-colors">
                    <Phone className="h-5 w-5" />
                  </div>
                  <span className="text-lg">(19) 99733-0658</span>
                </a>

                <a 
                  href="mailto:contato@tabocaarquitetura.com.br"
                  className="flex items-center gap-3 text-white/90 hover:text-white transition-colors group"
                >
                  <div className="w-10 h-10 rounded-full bg-white/20 flex items-center justify-center group-hover:bg-white/30 transition-colors">
                    <Mail className="h-5 w-5" />
                  </div>
                  <span className="text-lg">contato@tabocaarquitetura.com.br</span>
                </a>

                <div className="flex items-center gap-3 text-white/90">
                  <div className="w-10 h-10 rounded-full bg-white/20 flex items-center justify-center">
                    <MapPin className="h-5 w-5" />
                  </div>
                  <span className="text-lg">Limeira/SP</span>
                </div>
              </div>

              {/* Social Media */}
              <div className="mt-8">
                <h4 className="text-xl font-bold mb-4">Siga-nos</h4>
                <div className="flex gap-4">
                  <a 
                    href="https://instagram.com/taboca.arq"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-12 h-12 rounded-full bg-white/20 flex items-center justify-center hover:bg-white/30 transition-colors"
                    aria-label="Instagram Taboca"
                  >
                    <Instagram className="h-6 w-6" />
                  </a>
                  <a 
                    href="https://instagram.com/minha.casamaisbonita"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-12 h-12 rounded-full bg-white/20 flex items-center justify-center hover:bg-white/30 transition-colors"
                    aria-label="Instagram Minha Casa Mais Bonita"
                  >
                    <Instagram className="h-6 w-6" />
                  </a>
                  <a 
                    href="https://facebook.com/taboca.arq"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-12 h-12 rounded-full bg-white/20 flex items-center justify-center hover:bg-white/30 transition-colors"
                    aria-label="Facebook"
                  >
                    <Facebook className="h-6 w-6" />
                  </a>
                  <a 
                    href="https://youtube.com/@taboca.arq"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-12 h-12 rounded-full bg-white/20 flex items-center justify-center hover:bg-white/30 transition-colors"
                    aria-label="YouTube"
                  >
                    <Youtube className="h-6 w-6" />
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="pt-8 border-t border-white/20 text-center text-white/80">
            <p>© {new Date().getFullYear()} Taboca Arquitetura e Cidades. Todos os direitos reservados.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
